import { render, staticRenderFns } from "./CommonExam.vue?vue&type=template&id=51521526"
import script from "./CommonExam.vue?vue&type=script&lang=js"
export * from "./CommonExam.vue?vue&type=script&lang=js"
import style0 from "./CommonExam.vue?vue&type=style&index=0&id=51521526&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports